import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8","key":"svg-0"}],["path",{"d":"M17 17l4 4m0 -4l-4 4","key":"svg-1"}]]

const IconScriptX = createReactComponent('outline', 'script-x', 'ScriptX', __iconNode);

export default IconScriptX;